import ErrorImg from '../assets/full_page_error.svg?react';
import './ErrorView.less';

const ErrorView = ({ title }: { title?: string }) => {
  return (
    <div className={'error-view-container'}>
      <ErrorImg />
      <h3>{title ?? 'Something unexpected occurred'}</h3>
    </div>
  );
};

export { ErrorView };
